import { Lock } from '@mui/icons-material';
import { Box } from '@mui/material';

import { selectEarlyFeatureCode } from '@/domain/early-feature/early-feature.selector';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { useAppSelector } from '@/ui/hook/store';

export function DevEarlyFeature() {
  return (
    <>
      <EarlyFeatureExample />
    </>
  );
}

function EarlyFeatureExample() {
  const earlyFeatureCode = useAppSelector(selectEarlyFeatureCode);
  const canClickOnButton = earlyFeatureCode === 'dev-example';

  return (
    <>
      <h3>Early feature : demo with 'dev-example' code</h3>
      <p>- this button is disabled when you arrive on the page</p>
      <p>canClickOnButton : {JSON.stringify(canClickOnButton)}</p>
      <FSPrimaryButton disabled={!canClickOnButton}>
        Click on button
        {!canClickOnButton && (
          <Box sx={{ ml: 1 }}>
            <Lock />
          </Box>
        )}
      </FSPrimaryButton>
      <p>Enable it: </p>
      <p>
        - type <u>?early-feature=dev-example</u> on the url
      </p>
      <p>
        - type <u>earlyFeature('dev-example')</u> in the console
      </p>
    </>
  );
}
